import * as React from 'react';

import { ChevronLeftIcon, CodeIcon } from '../../../icons';
import { cx } from '../../../utils/cx';
import { filterNullsAndUndefined } from '../../../utils/filterUtils';

interface IJsonDebugRowProps {
  label: string;
  rawJson: unknown;
  isAdmin?: boolean;
}

const JsonDebugRow = ({ label, rawJson, isAdmin = false }: IJsonDebugRowProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  if (!isAdmin || !rawJson) {
    return null;
  }

  return (
    <div className="min-h-18 flex flex-col gap-2 px-4 py-6">
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className="text-md text-tertiary flex w-full flex-1 cursor-pointer items-center gap-1 font-medium"
      >
        <CodeIcon className="size-4.5 shrink-0" />
        {label} (admin only)
        <ChevronLeftIcon
          className={cx(
            'text-quaternary size-4.5 ml-auto shrink-0 transition-transform duration-200',
            isExpanded && '-rotate-90'
          )}
        />
      </div>
      {isExpanded && (
        <pre className="bg-secondary_subtle m-0 max-h-96 overflow-auto whitespace-pre-wrap rounded-lg p-3 text-xs">
          {JSON.stringify(filterNullsAndUndefined(rawJson), null, 2)}
        </pre>
      )}
    </div>
  );
};

export default JsonDebugRow;
